import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useFetchList from 'hooks/useFetchList';
import { useSelector } from 'react-redux';
import { NULL_QUERY_DELAY } from '../../Shared/constants';
import { GET_BOT_ACTIVITIES_COLUMNS } from '../constants';
import QhsTable from '../../Shared/Table/Table';
import { convertDataFromApi, useGenerateColumns } from '../../Shared/Table/helpers';
import TableActions from './widgets/TableActions';
import { TABLE_KEYS } from '../../../redux_store/reducer/reducers/tableReducer/tableReducer';

const BotActivityList = ({ setFilterStyle, setTotalCount, tableTitle }) => {
  const {
    patientUuid: paramsPatientUuid,
    accountUuid: paramAccountUuid,
  } = useParams();
  const isPatientPage = Boolean(paramsPatientUuid);
  const {
    metadata: {
      currentAccount,
    },
    isDistributionSponsor,
  } = useSelector((state) => state.user);
  const [modifiedReportables, setModifiedReportables] = useState();
  const tableKey = isDistributionSponsor ? TABLE_KEYS.botActivitiesDSTable : TABLE_KEYS.botActivitiesTable;
  const args = useMemo(() => ({ isPatientPage: isPatientPage }), [isPatientPage]);
  const columns = useGenerateColumns(GET_BOT_ACTIVITIES_COLUMNS, tableKey, args, {}).columns;
  const fields = columns.map((columnData) => columnData.accessorKey).join();

  const baseEndpoint = `/accounts/${
    paramAccountUuid || currentAccount.uuid
  }/bot-activities`;
  const {
    items,
    totalAccountsCount,
    totalCount,
    completionRate,
    aggregations,
    reloadData,
    clearFilter,
    sort,
    onSort,
    filter,
    onFilter,
    loading: dataLoading,
    onLoadMoreRows,
  } = useFetchList({
    baseEndpoint,
    baseParams: {
      fields: fields,
      q: isPatientPage ? `patientUUID:${paramsPatientUuid}` : undefined,
    },
    tableKey,
    canLoad: fields.length,
  });

  const [prevTotalCount, setPrevTotalCount] = useState(totalCount);

  useEffect(() => {
    if (items) {
      const newModifiedItems = convertDataFromApi(items, tableKey, filter);
      setModifiedReportables(newModifiedItems);
    }
  }, [items]);

  useEffect(() => {
    if (prevTotalCount !== totalCount) {
      setFilterStyle(!!(filter?.reduce((accumulator, { value }) => {
        return accumulator + value.toString().replaceAll(' ', '').length;
      }, 0)));
      setPrevTotalCount(totalCount);
      setTotalCount && setTotalCount(totalCount);
    }
  }, [filter, totalCount]);

  const reloadReportableList = (hasFilter) => {
    if (!hasFilter) {
      clearFilter();
    } else {
      reloadData({ delay: NULL_QUERY_DELAY });
    }
  };

  return <QhsTable
    tableKey={tableKey}
    columns={columns}
    data={modifiedReportables || []}
    fetchNextPage={onLoadMoreRows}
    isFetching={dataLoading}
    isLoading={dataLoading && !modifiedReportables}
    totalRowCount={totalCount}
    sorting={sort}
    setSorting={onSort}
    filter={filter}
    setFilters={onFilter}
    tableTitle={tableTitle}
    showRefreshTableButton
    reloadData={reloadReportableList}
    menuActions={<TableActions
      totalCount={totalCount}
      tableSort={sort}
      tableFilter={filter}
      columns={columns}
      isPatientPage={isPatientPage}
      aggregations={aggregations}
    />}
  />;
};

export default BotActivityList;

